import React from "react";
import { Route, Switch } from "react-router-dom";
// import Inbox from "./inbox/index";
import View from "./list";
import Creacte from "./create";
import Update from "./update";
import "./index.css";
const Production = ({ match }) => {
  return (
    <Switch>
      <Route path={`${match.url}/add`} component={Creacte} />
      <Route path={`${match.url}/:bannerImageId/update`} component={Update} />
      <Route path={`${match.url}/:bannerStatus`} component={View} />
    </Switch>
  );
};

export default Production;
